import {
  ObjectRelation,
  ObjectType,
  permissionsApiSlice,
} from "web/features/permissions/permissionsApiSlice";

interface PermissionConfig {
  objectId?: string;
  objectType?: ObjectType;
  objectRelation?: ObjectRelation;
}

const usePermission = (config: PermissionConfig): boolean => {
  const { data: permissions } =
    permissionsApiSlice.endpoints.getUserPermissions.useQueryState();

  if (!permissions || !permissions.length) return false;

  return permissions.some(
    (p) =>
      (!config.objectId || p.objectId === config.objectId) &&
      (!config.objectType || p.objectType === config.objectType) &&
      (!config.objectRelation || p.objectRelation === config.objectRelation)
  );
};

export default usePermission;
